import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { EtapaComboService } from '../../../../core/services/etapa-combo.service';
import { ComboBase } from 'src/app/models/comboModel';

@Component({
    selector: 'max-etapa-combo',
    templateUrl: './etapa-combo.component.html'
})
export class EtapaComboComponent implements OnInit {

    public lista!: ComboBase[];
    public selectedItem!: ComboBase;
    @Input() code: string = "";
    @Input() class!: string;
    @Input() selectedItemForm!: ComboBase;
    @Output() aoLimparSelecionado = new EventEmitter();
    @Output() itemSelecionado = new EventEmitter();

    constructor(private service: EtapaComboService) { }

    ngOnInit(): void {
        this.code = "";


        if (this.selectedItemForm != null) {
            this.code = this.selectedItemForm.code ? this.selectedItemForm.code : '';
            this.selectedItem = this.selectedItemForm;
        }
        this.getLista();
    }

    getLista() {
        this.service.getLista()
            .subscribe(
                (res) => {
                    if (res) {
                        res.forEach(f => {
                            f.text = f.code + ' - ' + f.text;
                        });
                        this.lista = res.sort((a: any, b) => a.text.localeCompare(b.text));
                    }
                },
                err => {
                    console.log(`EtapaList ` + err);
                }
            );
    }

    onClear(event: any) {
        this.aoLimparSelecionado.emit(event);
    }
    onChange(event: any) {
        this.itemSelecionado.emit(event.value);
    }
}